// @ts-nocheck
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { toREM } from '../../../../utils/generalUtils';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      margin: 30,
      textAlign: 'center',
    },
    successMessage: {
      color: STYLE.COLOR.SUCCESS,
      fontWeight: 'bold',
      fontSize: '20px',
    },
    errorMessage: {
      color: STYLE.COLOR.ERROR,
      fontWeight: 'bold',
      fontSize: '20px',
    },
  })
);
